import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { enabled: Boolean, url: String, interval: { type: Number, default: 5000 } }

  connect() {
    if (this.enabledValue) this.timer = window.setInterval(() => this.refresh(), this.intervalValue)
  }

  async refresh() {
    if (this.pending || document.hidden || document.querySelector(".modal.show, form[aria-busy='true']")) return
    this.pending = true
    this.abortController = new AbortController()
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        signal: this.abortController.signal
      })
      if (!response.ok) return
      const markup = await response.text()
      if (this.element.isConnected) Turbo.renderStreamMessage(markup)
    } catch (error) {
      // A later interval retries transient network failures. Navigation aborts
      // prevent an old page's response from replacing the current page.
      if (error.name !== "AbortError") this.pending = false
    } finally {
      this.pending = false
    }
  }

  disconnect() {
    window.clearInterval(this.timer)
    this.abortController?.abort()
  }
}
